/* eslint-disable no-unused-expressions */
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'

import { Checkbox, TextField } from '@material-ui/core'

import { matchSorter } from 'match-sorter'

const MultiSelect = ({
  items,
  selectedValues,
  label,
  size = 'medium',
  placeholder,
  selectAllLabel,
  noOptionsText,
  limitTags,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
  disabled,
  keyFilterField,
  error,
  helperText,
  showSelectAll,
  forcePopupIcon,
  orderField,
  chip,
  InputLabelProps,
  disableItem,
  disableClear,
  getOptionSelected,
  disableCloseOnSelect = true,
  onBlur = () => {},
  ...props
}) => {
  const allSelected = items.length === selectedValues.length

  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected)
  }

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === 'select-option' || reason === 'remove-option') {
      if (selectedOptions.find(option => option.value === 'select-all')) {
        handleToggleSelectAll()
      } else {
        onToggleOption && onToggleOption(selectedOptions)
      }
    } else if (reason === 'clear') {
      onClearOptions && onClearOptions()
    }
  }

  const optionRenderer = (option, { selected }) => {
    if (option.value === 'noValue') {
      return <>{getOptionLabel(option)}</>
    }
    const selectAllProps = option.value === 'select-all' ? { checked: allSelected } : {}
    return (
      <>
        <Checkbox checked={selected} {...selectAllProps} />
        {getOptionLabel(option)}
      </>
    )
  }

  const filterOptions = (opt, { inputValue }) =>
    matchSorter(opt, inputValue, {
      baseSort: (a, b) =>
        a.item[orderField ?? keyFilterField] < b.item[orderField ?? keyFilterField] ? -1 : 1,
      keys: [{ threshold: matchSorter.rankings.CONTAINS, key: keyFilterField }],
    })

  return (
    <Autocomplete
      disableClearable={disableClear}
      multiple
      freeSolo
      clearOnBlur
      onBlur={onBlur}
      limitTags={limitTags}
      options={items}
      value={selectedValues}
      disableCloseOnSelect={disableCloseOnSelect}
      disabled={disabled}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={disableItem}
      forcePopupIcon={forcePopupIcon}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filterOptions(options, params)
        if (filtered.length === 0) {
          return [{ name: 'Não encontramos nenhum resultado', value: 'noValue' }]
        }
        if (options.length > 0 && showSelectAll) {
          return [{ name: selectAllLabel, value: 'select-all' }, ...filtered]
        }
        return [...filtered]
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderTags={chip}
      renderInput={params => (
        <TextField
          {...params}
          size={size || props.size}
          label={label}
          style={{
            backgroundColor: disabled ? '#E0E0E0' : '',
          }}
          disabled={disabled}
          variant="outlined"
          fullWidth
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          InputLabelProps={InputLabelProps}
        />
      )}
    />
  )
}

MultiSelect.defaultProps = {
  limitTags: 4,
  items: [],
  selectedValues: [],
  getOptionLabel: value => value,
  getOptionSelected: (option, anotherOption) => option.id === anotherOption.id,
}

export default MultiSelect
